export const THEME_MODE_STORAGE_KEY = 'locatorlogix-theme-mode';

export const themeModes = Object.freeze({
    system: 'system',
    light: 'light',
    dark: 'dark',
});

const isThemeMode = value => Object.values(themeModes).includes(value);

const getStorage = () => {
    try {
        return window.localStorage;
    } catch(error) {
        return null;
    }
};

const getSystemThemeQuery = () => {
    try {
        return window.matchMedia('(prefers-color-scheme: dark)');
    } catch(error) {
        return null;
    }
};

export const getStoredThemeMode = () => {
    const mode = getStorage()?.getItem(THEME_MODE_STORAGE_KEY);
    return isThemeMode(mode) ? mode : themeModes.light;
};

export const resolveDarkTheme = (mode = getStoredThemeMode()) => {
    if(mode === themeModes.dark) {
        return true;
    }
    if(mode === themeModes.light) {
        return false;
    }
    return getSystemThemeQuery()?.matches
        ?? process.env.VUE_APP_DARK_MODE === 'true';
};

export const applyThemeMode = (vuetify, mode) => {
    vuetify.theme.dark = resolveDarkTheme(mode);
};

export const storeThemeMode = mode => {
    if(!isThemeMode(mode)) {
        throw new Error(`Unsupported theme mode: ${mode}`);
    }
    getStorage()?.setItem(THEME_MODE_STORAGE_KEY, mode);
};

export const watchSystemTheme = listener => {
    const query = getSystemThemeQuery();
    if(!query) {
        return () => {};
    }

    const onChange = event => listener(event.matches);
    if(typeof query.addEventListener === 'function') {
        query.addEventListener('change', onChange);
        return () => query.removeEventListener('change', onChange);
    }

    query.addListener(onChange);
    return () => query.removeListener(onChange);
};
